/* ==========================================================================
   OGGON Wishlist  v2.0 — Premium
   --------------------------------------------------------------------------
   • Heart on every product image store-wide, with particle burst and a
     fly-to-header animation when a chair is saved.
   • Header heart with live count and ping halo.
   • Premium slide-in drawer: trust strip, stock badges, price-drop alerts,
     "saved X ago", per-item Buy Now (straight to checkout), running total
     with savings, CHECKOUT ALL, WhatsApp + copy-link sharing.
   • Shareable wishlist links (?oggon_wl=...) open a "shared with you" view.
   • Bottom-left toast with Undo on remove.
   • Saved in the browser, synced across tabs; merges a logged-in customer's
     metafield list and POSTs to OggonWishlistConfig.syncUrl when configured.
   ========================================================================== */

(function () {
  'use strict';

  var CFG = window.OggonWishlistConfig || {};
  var KEY = 'oggon_wishlist_v1';
  var CACHE_KEY = 'oggon_wishlist_products_v2'; // v2: variants carry their own images
  var TOAST_MS = 4500;
  var REDUCED = false;
  try { REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { /* old browser */ }

  var ICON_HEART =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
  var ICON_CLOSE =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  var ICON_BOLT =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M13 2 3 14h7l-1 8 10-12h-7l1-8z"/></svg>';
  var ICON_BAG =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 7h12l1 14H5L6 7z"/><path d="M9 10V6a3 3 0 0 1 6 0v4"/></svg>';
  var ICON_LINK =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>';
  var ICON_WA =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M21 11.5a8.5 8.5 0 0 1-12.3 7.6L3 21l1.9-5.7A8.5 8.5 0 1 1 21 11.5z"/><path d="M8.5 9.5c.5 2.5 3 5 5.5 5.5l1.5-1.5 2 1c-.5 1.5-2 2-3.5 1.5-3-1-5.5-3.5-6.5-6.5-.5-1.5 0-3 1.5-3.5l1 2-1.5 1.5z"/></svg>';
  var ICON_TRUCK =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M1 5h13v11H1z"/><path d="M14 9h4l4 4v3h-8"/><circle cx="6" cy="18.5" r="2"/><circle cx="17.5" cy="18.5" r="2"/></svg>';
  var ICON_SHIELD =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2 4 5.5V11c0 5 3.4 9.3 8 11 4.6-1.7 8-6 8-11V5.5L12 2z"/></svg>';
  var ICON_CHECK =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 12.5 9.5 18 20 6.5"/></svg>';
  var ICON_DOWN =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 4v14m0 0-6-6m6 6 6-6"/></svg>';

  /* ---------------------------------------------------------------- utils */

  function qsa(sel, root) {
    try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
    catch (e) { return []; }
  }

  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, self = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(self, args); }, wait);
    };
  }

  function rootUrl() {
    var r = CFG.rootUrl || '/';
    return r.replace(/\/+$/, '');
  }

  function productUrl(handle) { return rootUrl() + '/products/' + handle; }

  function formatMoney(cents) {
    var amount = (Number(cents) || 0) / 100;
    var hasPaise = Math.round(amount * 100) % 100 !== 0;
    try {
      return new Intl.NumberFormat(CFG.locale || 'en-IN', {
        style: 'currency',
        currency: CFG.currency || 'INR',
        minimumFractionDigits: hasPaise ? 2 : 0,
        maximumFractionDigits: hasPaise ? 2 : 0
      }).format(amount);
    } catch (e) {
      return (CFG.currencySymbol || '₹') + amount.toFixed(hasPaise ? 2 : 0);
    }
  }

  function handleFromHref(href) {
    if (!href) return null;
    var m = String(href).match(/\/products\/([^/?#]+)/);
    if (!m) return null;
    var h = m[1].split('?')[0].split('#')[0];
    if (!h || h === 'undefined') return null;
    try { h = decodeURIComponent(h); } catch (e) { /* keep raw */ }
    return h.toLowerCase();
  }

  function variantFromHref(href) {
    if (!href) return null;
    var m = String(href).match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  function timeAgo(t) {
    if (!t) return '';
    var d = Date.now() - t;
    if (d < 0) return '';
    var day = 86400000;
    if (d < 3600000) return 'Saved just now';
    if (d < day) return 'Saved today';
    var n = Math.floor(d / day);
    if (n === 1) return 'Saved yesterday';
    if (n > 60) return 'Saved a while ago';
    return 'Saved ' + n + ' days ago';
  }

  /* -------------------------------------------------------------- storage */

  var memo = null;
  var lastRemoved = null;

  function read() {
    if (memo) return memo;
    var list = [];
    try {
      var raw = window.localStorage.getItem(KEY);
      if (raw) {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          list = parsed.filter(function (i) { return i && i.h; });
        }
      }
    } catch (e) { list = []; }
    memo = list;
    return list;
  }

  function persist(list) {
    memo = list;
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
  }

  function has(handle) {
    if (!handle) return false;
    var list = read();
    for (var i = 0; i < list.length; i++) if (list[i].h === handle) return true;
    return false;
  }

  function count() { return read().length; }

  function handles() { return read().map(function (i) { return i.h; }); }

  function savedVariant(handle) {
    var list = read();
    for (var i = 0; i < list.length; i++) if (list[i].h === handle) return list[i].v || null;
    return null;
  }

  function changed(detail) {
    refreshAllHearts();
    refreshHeader();
    if (drawer && drawer.classList.contains('is-open')) renderDrawer();
    pushSync();
    try {
      document.dispatchEvent(new CustomEvent('oggon:wishlist:change', {
        detail: { count: count(), handles: handles(), action: (detail && detail.action) || null, handle: (detail && detail.handle) || null }
      }));
    } catch (e) { /* older browsers */ }
  }

  function add(handle, variantId, restore) {
    if (!handle || has(handle)) return false;
    var list = read().slice();
    if (restore && typeof restore === 'object') {
      list.unshift(restore);
    } else {
      list.unshift({ h: handle, v: variantId || null, t: Date.now(), p: null });
    }
    persist(list);
    changed({ action: 'add', handle: handle });
    return true;
  }

  function remove(handle) {
    if (!handle) return false;
    var list = read();
    for (var i = 0; i < list.length; i++) {
      if (list[i].h === handle) { lastRemoved = list[i]; break; }
    }
    persist(list.filter(function (i) { return i.h !== handle; }));
    changed({ action: 'remove', handle: handle });
    return true;
  }

  function undoRemove() {
    if (!lastRemoved || has(lastRemoved.h)) return false;
    add(lastRemoved.h, lastRemoved.v, lastRemoved);
    lastRemoved = null;
    return true;
  }

  function setVariant(handle, variantId) {
    var list = read().slice();
    for (var i = 0; i < list.length; i++) {
      if (list[i].h === handle) { list[i].v = variantId || null; break; }
    }
    persist(list);
    pushSync();
  }

  // Remember the price at save time, so a later drop can be celebrated.
  function setPriceAtAdd(handle, price) {
    var list = read().slice();
    var touched = false;
    for (var i = 0; i < list.length; i++) {
      if (list[i].h === handle && (list[i].p == null)) { list[i].p = price; touched = true; break; }
    }
    if (touched) persist(list);
  }

  function priceAtAdd(handle) {
    var list = read();
    for (var i = 0; i < list.length; i++) if (list[i].h === handle) return list[i].p || null;
    return null;
  }

  /* --------------------------------------------- customer account syncing */

  function mergeCustomerList() {
    var remote = CFG.customer && CFG.customer.wishlist;
    if (!remote || !remote.length) return;
    var list = read().slice();
    var known = {};
    list.forEach(function (i) { known[i.h] = true; });
    var added = 0;
    remote.forEach(function (entry) {
      if (!entry) return;
      var parts = String(entry).split('|');
      var h = (parts[0] || '').trim().toLowerCase();
      var v = (parts[1] || '').trim() || null;
      if (!h || known[h]) return;
      known[h] = true;
      list.push({ h: h, v: v, t: 0, p: null });
      added++;
    });
    if (added) persist(list);
  }

  var pushSync = debounce(function () {
    if (!CFG.syncUrl || !CFG.customer || !CFG.customer.id) return;
    var payload = {
      customer_id: CFG.customer.id,
      items: read().map(function (i) { return i.v ? i.h + '|' + i.v : i.h; })
    };
    try {
      fetch(CFG.syncUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(function () { /* browser copy stays the source of truth */ });
    } catch (e) { /* no fetch */ }
  }, 900);

  /* --------------------------------------------------------- product data */

  var pCache = {};

  try {
    var rawCache = window.sessionStorage.getItem(CACHE_KEY);
    if (rawCache) pCache = JSON.parse(rawCache) || {};
  } catch (e) { pCache = {}; }

  function cacheProduct(handle, data) {
    pCache[handle] = data;
    try { window.sessionStorage.setItem(CACHE_KEY, JSON.stringify(pCache)); } catch (e) { /* full */ }
  }

  function fetchProduct(handle) {
    if (pCache[handle]) return Promise.resolve(pCache[handle]);
    return fetch(productUrl(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('not found'); return r.json(); })
      .then(function (p) {
        var slim = {
          id: p.id,
          handle: p.handle,
          title: p.title,
          url: rootUrl() + p.url,
          image: p.featured_image || (p.images && p.images[0]) || null,
          available: p.available,
          price: p.price,
          compare_at_price: p.compare_at_price_max || p.compare_at_price || 0,
          variants: (p.variants || []).map(function (v) {
            return {
              id: v.id,
              title: v.title,
              price: v.price,
              compare_at_price: v.compare_at_price,
              available: v.available,
              image: (v.featured_image && v.featured_image.src) ? v.featured_image.src : null
            };
          })
        };
        cacheProduct(handle, slim);
        return slim;
      });
  }

  function thumb(url, size) {
    if (!url) return '';
    return String(url).replace(/(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_' + size + 'x$1$3');
  }

  /* ------------------------------------------------- heart injection engine */

  var SKIP_SEL = [
    '[data-oggon-wl-skip]',
    'header', 'footer',
    '.oggon-wl-drawer', '.oggon-wl-toast', '.oggon-wl-item',
    'cart-drawer', '.cart-drawer', '.drawer',
    'cart-notification', '.cart-notification',
    '.quick-add-modal', '.quick-order-list',
    'predictive-search', '.predictive-search', '.search__results',
    '.header-wrapper', '.site-header', '.shopify-section-header',
    '#shopify-section-header', '#shopify-section-footer'
  ].join(',');

  var MEDIA_SEL = [
    '.card__media', '.media', '.card__inner',
    '[class*="image-wrapper"]', '[class*="img-wrapper"]',
    '[class*="image-wrap"]', '[class*="img-wrap"]',
    '[class*="product-image"]', '[class*="product__image"]',
    '[class*="media-wrapper"]', '[class*="thumb"]'
  ].join(',');

  function inSkipZone(el) {
    try { return !!el.closest(SKIP_SEL); } catch (e) { return false; }
  }

  function findCard(anchor) {
    var el = anchor, depth = 0;
    while (el && depth < 9) {
      if (el.tagName === 'BODY') return null;
      var img = el.querySelector('img, svg.placeholder-svg, .placeholder-svg');
      if (img) return el;
      el = el.parentElement;
      depth++;
    }
    return null;
  }

  function findImage(card) {
    var imgs = qsa('img', card);
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      if (im.closest('.oggon-wl-heart')) continue;
      var cls = (im.className && im.className.baseVal !== undefined) ? '' : String(im.className || '');
      if (/icon|logo|badge|flag|payment|sprite/i.test(cls)) continue;
      return im;
    }
    return null;
  }

  // Containers pushed behind the card's click overlay bury anything inside.
  function zBuried(el) {
    var cs = window.getComputedStyle(el);
    var z = cs.zIndex;
    return cs.position !== 'static' && z !== 'auto' && parseInt(z, 10) < 1;
  }

  function isBuried(host, card) {
    var el = host, guard = 0;
    while (el && el !== card && el !== document.body && guard < 8) {
      if (zBuried(el)) return true;
      el = el.parentElement;
      guard++;
    }
    return false;
  }

  // A transform/opacity/filter/z-index box becomes a stacking context that
  // traps its children below the card overlay (Dawn transforms .card__inner).
  function createsStackingContext(el) {
    var cs = window.getComputedStyle(el);
    if (cs.transform && cs.transform !== 'none') return true;
    if (cs.filter && cs.filter !== 'none') return true;
    if (cs.perspective && cs.perspective !== 'none') return true;
    if (parseFloat(cs.opacity) < 1) return true;
    if (cs.isolation === 'isolate') return true;
    if (cs.mixBlendMode && cs.mixBlendMode !== 'normal') return true;
    if (cs.willChange && /transform|opacity|filter/.test(cs.willChange)) return true;
    if (cs.contain && /paint|layout|strict|content/.test(cs.contain)) return true;
    if (cs.position !== 'static' && cs.zIndex !== 'auto') return true;
    return false;
  }

  function liftHost(from) {
    var el = from, fallback = null, guard = 0;
    var baseWidth = from.getBoundingClientRect().width || 0;
    while (el && el !== document.body && guard < 6) {
      var cs = window.getComputedStyle(el);
      if (baseWidth && el.getBoundingClientRect().width > baseWidth * 1.8) break;
      if (!createsStackingContext(el) && !zBuried(el)) {
        if (cs.position !== 'static') return el;
        if (!fallback) fallback = el;
      }
      el = el.parentElement;
      guard++;
    }
    return fallback || from;
  }

  function findHost(card, img) {
    var host = null;
    try { host = img.closest(MEDIA_SEL); } catch (e) { host = null; }
    if (!host || !card.contains(host)) host = img.parentElement;
    if (host && host.tagName === 'A') {
      var cs = window.getComputedStyle(host);
      if (cs.display === 'inline') host = host.parentElement;
    }
    if (!host || host === document.body) host = card;
    if (isBuried(host, card) || createsStackingContext(card)) host = liftHost(card);
    return host;
  }

  // After paint, prove each visible heart is genuinely clickable; relocate the
  // covered ones to a cleaner ancestor box.
  function verifyClickable() {
    qsa('.oggon-wl-heart:not([data-wl-ok])').forEach(function (h) {
      var r = h.getBoundingClientRect();
      if (!r.width || r.bottom < 0 || r.top > (window.innerHeight || 0)) return;
      if (r.right < 0 || r.left > (window.innerWidth || 0)) return;

      var hit = document.elementFromPoint(r.left + r.width / 2, r.top + r.height / 2);
      if (!hit || h.contains(hit)) { h.setAttribute('data-wl-ok', '1'); return; }

      var tries = parseInt(h.getAttribute('data-wl-try') || '0', 10);
      if (tries >= 2) { h.setAttribute('data-wl-ok', '1'); return; }
      h.setAttribute('data-wl-try', String(tries + 1));

      var lifted = liftHost(h.parentElement);
      if (!lifted || lifted === h.parentElement) { h.setAttribute('data-wl-ok', '1'); return; }
      if (window.getComputedStyle(lifted).position === 'static') lifted.classList.add('oggon-wl-host');
      lifted.appendChild(h);
    });
  }

  function buildHeart(handle, variantId, extraClass) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'oggon-wl-heart' + (extraClass ? ' ' + extraClass : '');
    b.setAttribute('data-oggon-wl-handle', handle);
    if (variantId) b.setAttribute('data-oggon-wl-variant', variantId);
    b.setAttribute('aria-pressed', has(handle) ? 'true' : 'false');
    b.setAttribute('aria-label', has(handle) ? 'Remove from wishlist' : 'Add to wishlist');
    b.setAttribute('title', has(handle) ? 'Remove from wishlist' : 'Add to wishlist');
    if (has(handle)) b.classList.add('is-active');
    b.innerHTML = ICON_HEART;
    return b;
  }

  function scanCards(scope) {
    var anchors = qsa('a[href*="/products/"]', scope || document);
    for (var i = 0; i < anchors.length; i++) {
      var a = anchors[i];
      if (a.closest('.oggon-wl-heart')) continue;
      if (inSkipZone(a)) continue;

      var handle = handleFromHref(a.getAttribute('href'));
      if (!handle) continue;

      var card = findCard(a);
      if (!card) continue;
      if (card.getAttribute('data-oggon-wl-done') === handle) continue;
      if (qsa('.oggon-wl-heart[data-oggon-wl-handle="' + handle + '"]', card).length) continue;

      var rect = card.getBoundingClientRect();
      if (rect.width && rect.width < 110) continue;

      var img = findImage(card);
      if (!img) continue;
      var irect = img.getBoundingClientRect();
      if (irect.width && irect.width < 70) continue;

      var host = findHost(card, img);
      if (!host) continue;
      if (host.querySelector('.oggon-wl-heart')) continue;

      if (window.getComputedStyle(host).position === 'static') host.classList.add('oggon-wl-host');
      host.appendChild(buildHeart(handle, variantFromHref(a.getAttribute('href'))));
      card.setAttribute('data-oggon-wl-done', handle);
    }
  }

  function scanProductPage() {
    var p = CFG.product;
    if (!p || !p.handle) return;
    if (document.querySelector('.oggon-wl-heart--pdp')) return;

    var host =
      document.querySelector('.product__media-wrapper .product__media') ||
      document.querySelector('media-gallery .product__media') ||
      document.querySelector('.product__media') ||
      null;

    if (!host) {
      var main = document.getElementById('MainContent') || document.body;
      var imgs = qsa('img', main).filter(function (im) {
        return !inSkipZone(im) && im.getBoundingClientRect().width >= 220;
      });
      if (imgs.length) host = imgs[0].parentElement;
    }
    if (!host || inSkipZone(host)) return;
    if (host.querySelector('.oggon-wl-heart')) return;

    if (window.getComputedStyle(host).position === 'static') host.classList.add('oggon-wl-host');
    host.appendChild(buildHeart(p.handle, currentVariantId() || p.variantId, 'oggon-wl-heart--pdp'));
  }

  function currentVariantId() {
    var m = window.location.search.match(/[?&]variant=(\d+)/);
    if (m) return m[1];
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"]:not([disabled])');
    return input ? input.value : null;
  }

  function refreshAllHearts() {
    qsa('.oggon-wl-heart').forEach(function (b) {
      var on = has(b.getAttribute('data-oggon-wl-handle'));
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Add to wishlist');
      b.setAttribute('title', on ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  /* ------------------------------------------------------------ effects */

  function burst(btn) {
    if (REDUCED) return;
    var old = btn.querySelector('.oggon-wl-burst');
    if (old) old.parentNode.removeChild(old);
    var wrap = document.createElement('span');
    wrap.className = 'oggon-wl-burst';
    var html = '';
    for (var i = 0; i < 8; i++) {
      var ang = (Math.PI * 2 / 8) * i + 0.4;
      var dist = 22 + (i % 2) * 8;
      html += '<i style="--dx:' + Math.round(Math.cos(ang) * dist) + 'px;--dy:' + Math.round(Math.sin(ang) * dist) + 'px"></i>';
    }
    wrap.innerHTML = html;
    btn.appendChild(wrap);
    setTimeout(function () { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }, 700);
  }

  function flyToHeader(img) {
    if (REDUCED || !img || !headerBtn) return;
    var from = img.getBoundingClientRect();
    var to = headerBtn.getBoundingClientRect();
    if (!from.width || !to.width) return;

    var size = Math.min(from.width, from.height, 120);
    var clone = document.createElement('div');
    clone.className = 'oggon-wl-fly';
    clone.style.width = size + 'px';
    clone.style.height = size + 'px';
    clone.style.left = (from.left + from.width / 2 - size / 2) + 'px';
    clone.style.top = (from.top + from.height / 2 - size / 2) + 'px';
    clone.innerHTML = '<img src="' + esc(img.currentSrc || img.src) + '" alt="">';
    document.body.appendChild(clone);

    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        clone.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(0.12)';
        clone.style.opacity = '0.2';
        clone.style.borderRadius = '50%';
      });
    });
    setTimeout(function () {
      if (clone.parentNode) clone.parentNode.removeChild(clone);
      bumpHeader();
    }, 720);
  }

  /* ------------------------------------------------------- header control */

  var headerBtn = null;

  function buildHeaderButton(cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls || 'oggon-wl-headerbtn';
    b.setAttribute('aria-label', 'Open wishlist');
    b.setAttribute('title', 'Wishlist');
    b.innerHTML = ICON_HEART + '<span class="oggon-wl-count" aria-hidden="true">0</span>';
    b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
    return b;
  }

  function mountHeader() {
    if (headerBtn && document.body.contains(headerBtn)) return true;

    var slot = document.querySelector('[data-oggon-wishlist-header]');
    if (slot) {
      headerBtn = buildHeaderButton();
      slot.appendChild(headerBtn);
      refreshHeader();
      return true;
    }

    var scopes = qsa('header, [class*="header"], [id*="header"], [class*="Header"]').filter(function (el) {
      return el.getBoundingClientRect().top < 400;
    });

    for (var i = 0; i < scopes.length; i++) {
      var scope = scopes[i];
      var cart =
        scope.querySelector('a#cart-icon-bubble') ||
        scope.querySelector('a[href$="/cart"]') ||
        scope.querySelector('a[href*="/cart"]') ||
        scope.querySelector('[class*="cart-icon"], [class*="cart-link"], [class*="cart-toggle"], [data-cart-drawer-toggle]');
      if (!cart || !cart.parentElement) continue;
      scope.setAttribute('data-oggon-wl-skip', '');
      headerBtn = buildHeaderButton();
      cart.parentElement.insertBefore(headerBtn, cart);
      refreshHeader();
      return true;
    }
    return false;
  }

  function mountFloating() {
    if (headerBtn && document.body.contains(headerBtn)) return;
    headerBtn = buildHeaderButton('oggon-wl-headerbtn oggon-wl-float');
    document.body.appendChild(headerBtn);
    refreshHeader();
  }

  function refreshHeader() {
    var n = count();
    qsa('.oggon-wl-headerbtn').forEach(function (btn) {
      var bubble = btn.querySelector('.oggon-wl-count');
      if (bubble) {
        var txt = n > 99 ? '99+' : String(n);
        if (bubble.textContent !== txt) {
          bubble.textContent = txt;
          bubble.classList.remove('is-flip');
          void bubble.offsetWidth;
          bubble.classList.add('is-flip');
        }
        bubble.classList.toggle('is-visible', n > 0);
      }
      btn.classList.toggle('has-items', n > 0);
      btn.setAttribute('aria-label', n ? 'Open wishlist, ' + n + ' item' + (n === 1 ? '' : 's') : 'Open wishlist');
    });
    qsa('[data-oggon-wishlist-count]').forEach(function (el) { el.textContent = String(n); });
  }

  function bumpHeader() {
    qsa('.oggon-wl-headerbtn').forEach(function (btn) {
      btn.classList.remove('is-bump');
      void btn.offsetWidth;
      btn.classList.add('is-bump');
      setTimeout(function () { btn.classList.remove('is-bump'); }, 750);
    });
  }

  /* ---------------------------------------------------------------- drawer */

  var overlay = null, drawer = null, lastFocus = null;
  var sharedHandles = null; // non-null => "shared with you" view

  function buildDrawer() {
    overlay = document.createElement('div');
    overlay.className = 'oggon-wl-overlay';
    overlay.addEventListener('click', closeDrawer);

    drawer = document.createElement('div');
    drawer.className = 'oggon-wl-drawer';
    drawer.id = 'oggon-wl-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Wishlist');
    drawer.setAttribute('data-oggon-wl-skip', '');
    drawer.innerHTML =
      '<div class="oggon-wl-drawer__head">' +
        '<h2 class="oggon-wl-drawer__title">' + ICON_HEART +
          '<span data-wl-title>My Wishlist</span>' +
          '<span class="oggon-wl-chip" data-wl-chip hidden>0</span>' +
        '</h2>' +
        '<button type="button" class="oggon-wl-drawer__close" aria-label="Close wishlist">' + ICON_CLOSE + '</button>' +
      '</div>' +
      '<div class="oggon-wl-trust">' +
        '<span>' + ICON_TRUCK + 'FREE PAN-INDIA DELIVERY</span>' +
        '<span>' + ICON_SHIELD + '3-YEAR WARRANTY</span>' +
        '<span>' + ICON_CHECK + 'BIFMA-TESTED BUILD</span>' +
      '</div>' +
      '<div data-wl-sharedbar></div>' +
      '<div class="oggon-wl-drawer__body" data-wl-body></div>' +
      '<div class="oggon-wl-drawer__foot" data-wl-foot hidden>' +
        '<div class="oggon-wl-totals"><span class="t-label">Total value</span><span class="t-value" data-wl-total>—</span></div>' +
        '<div class="oggon-wl-savings"><span class="s-label" data-wl-note></span><span class="s-value" data-wl-savings hidden></span></div>' +
        '<button type="button" class="oggon-wl-checkoutall" data-wl-checkoutall>' + ICON_BAG + '<span data-wl-checkoutall-label>Checkout all</span></button>' +
        '<div class="oggon-wl-foot-row">' +
          '<button type="button" class="oggon-wl-footbtn oggon-wl-footbtn--wa" data-wl-share-wa>' + ICON_WA + 'WhatsApp</button>' +
          '<button type="button" class="oggon-wl-footbtn" data-wl-share-copy>' + ICON_LINK + 'Copy link</button>' +
          '<button type="button" class="oggon-wl-footbtn" data-wl-continue>Keep shopping</button>' +
        '</div>' +
      '</div>';

    drawer.querySelector('.oggon-wl-drawer__close').addEventListener('click', closeDrawer);

    document.body.appendChild(overlay);
    document.body.appendChild(drawer);
  }

  function openDrawer() {
    if (!drawer) buildDrawer();
    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.classList.add('oggon-wl-locked');
    renderDrawer();
    setTimeout(function () {
      var f = drawer.querySelector('.oggon-wl-drawer__close');
      if (f) f.focus();
    }, 60);
  }

  function closeDrawer() {
    if (!drawer) return;
    overlay.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.classList.remove('oggon-wl-locked');
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) { /* gone */ } }
  }

  function skeletonHtml(n) {
    var s = '';
    for (var i = 0; i < Math.min(n, 4); i++) {
      s += '<div class="oggon-wl-skel"><span class="s1"></span><div><span class="s2"></span><span class="s3"></span><span class="s4"></span></div></div>';
    }
    return s;
  }

  function emptyHtml() {
    return '<div class="oggon-wl-empty">' +
      '<div class="e-heart">' + ICON_HEART + '</div>' +
      '<h3>Your wishlist is waiting</h3>' +
      '<p>Tap the heart on any chair to keep it here — prices, colours and stock stay up to date for you.</p>' +
      '<a class="oggon-wl-buy" style="text-decoration:none" href="' + esc(rootUrl() + '/collections/all') + '">Explore chairs</a>' +
      '</div>';
  }

  function renderDrawer() {
    if (!drawer) return;
    if (sharedHandles) { renderSharedView(); return; }

    var body = drawer.querySelector('[data-wl-body]');
    var foot = drawer.querySelector('[data-wl-foot]');
    var note = drawer.querySelector('[data-wl-note]');
    var titleEl = drawer.querySelector('[data-wl-title]');
    var chip = drawer.querySelector('[data-wl-chip]');
    var sharedbar = drawer.querySelector('[data-wl-sharedbar]');
    sharedbar.innerHTML = '';

    var list = read();
    var n = list.length;

    titleEl.textContent = 'My Wishlist';
    chip.hidden = n === 0;
    chip.textContent = String(n);

    if (!n) {
      foot.hidden = true;
      body.innerHTML = emptyHtml();
      return;
    }

    foot.hidden = false;
    note.textContent = n + ' chair' + (n === 1 ? '' : 's') + ' saved';
    if (!body.querySelector('.oggon-wl-item')) body.innerHTML = skeletonHtml(n);

    Promise.all(list.map(function (item) {
      return fetchProduct(item.h)
        .then(function (p) { return { item: item, product: p }; })
        .catch(function () { return { item: item, product: null }; });
    })).then(function (rows) {
      var html = '';
      var missing = [];
      var idx = 0;

      rows.forEach(function (row) {
        if (!row.product) { missing.push(row.item.h); return; }
        html += itemHtml(row.product, row.item, idx++, 'mine');
      });

      if (missing.length) {
        persist(read().filter(function (i) { return missing.indexOf(i.h) === -1; }));
        refreshHeader();
      }

      body.innerHTML = html || emptyHtml();
      var left = read().length;
      chip.hidden = left === 0;
      chip.textContent = String(left);
      note.textContent = left + ' chair' + (left === 1 ? '' : 's') + ' saved';
      foot.hidden = left === 0;
      recalcTotals();
    });
  }

  function renderSharedView() {
    var body = drawer.querySelector('[data-wl-body]');
    var foot = drawer.querySelector('[data-wl-foot]');
    var titleEl = drawer.querySelector('[data-wl-title]');
    var chip = drawer.querySelector('[data-wl-chip]');
    var sharedbar = drawer.querySelector('[data-wl-sharedbar]');

    titleEl.textContent = 'Shared Wishlist';
    chip.hidden = false;
    chip.textContent = String(sharedHandles.length);
    foot.hidden = true;

    sharedbar.innerHTML =
      '<div class="oggon-wl-sharedbar">' +
        '<strong>A wishlist was shared with you</strong> — ' + sharedHandles.length +
        ' chair' + (sharedHandles.length === 1 ? '' : 's') + ' hand-picked on OGGON.' +
        '<div class="oggon-wl-minibtns">' +
          '<button type="button" class="oggon-wl-minibtn" data-wl-saveall>Save all to my wishlist</button>' +
          '<button type="button" class="oggon-wl-minibtn oggon-wl-minibtn--ghost" data-wl-exitshared>View my wishlist</button>' +
        '</div>' +
      '</div>';

    body.innerHTML = skeletonHtml(sharedHandles.length);

    Promise.all(sharedHandles.map(function (h) {
      return fetchProduct(h).then(function (p) { return p; }).catch(function () { return null; });
    })).then(function (products) {
      var html = '';
      var idx = 0;
      products.forEach(function (p) {
        if (!p) return;
        html += itemHtml(p, { h: p.handle, v: null, t: 0, p: null }, idx++, 'shared');
      });
      body.innerHTML = html || emptyHtml();
    });
  }

  function itemHtml(p, item, index, mode) {
    var variants = p.variants || [];
    var chosenId = item.v && variants.some(function (v) { return String(v.id) === String(item.v); })
      ? String(item.v) : null;
    var chosen = null;
    if (chosenId) chosen = variants.filter(function (v) { return String(v.id) === chosenId; })[0];
    if (!chosen) chosen = variants.filter(function (v) { return v.available; })[0] || variants[0] || null;

    var price = chosen ? chosen.price : p.price;
    var compare = chosen ? chosen.compare_at_price : p.compare_at_price;
    var available = chosen ? chosen.available : p.available;

    // Learn the saved-at price the first time we see this product.
    if (mode === 'mine') setPriceAtAdd(p.handle, price);

    var pct = 0;
    if (compare && compare > price) pct = Math.round((compare - price) * 100 / compare);

    var savedAt = mode === 'mine' ? priceAtAdd(p.handle) : null;
    var dropHtml = '';
    if (savedAt && price < savedAt) {
      dropHtml = '<div class="oggon-wl-drop">' + ICON_DOWN + 'Price dropped ' + esc(formatMoney(savedAt - price)) + ' since you saved it</div>';
    }

    var imgSrc = (chosen && chosen.image) || p.image;
    var img = imgSrc ? thumb(imgSrc, 280) : '';
    var url = p.url || productUrl(p.handle);

    var stockHtml = available
      ? '<span class="oggon-wl-stock">In stock</span>'
      : '<span class="oggon-wl-stock oggon-wl-stock--out">Sold out</span>';
    var agoTxt = mode === 'mine' ? timeAgo(item.t) : '';

    var priceHtml =
      '<div class="oggon-wl-item__price">' +
        '<span class="oggon-wl-now">' + esc(formatMoney(price)) + '</span>' +
        (compare && compare > price ? '<s class="oggon-wl-was">' + esc(formatMoney(compare)) + '</s>' : '') +
        (pct > 0 ? '<span class="oggon-wl-off">' + pct + '% OFF</span>' : '') +
      '</div>';

    var selectHtml = '';
    if (variants.length > 1) {
      selectHtml = '<select class="oggon-wl-variant" data-wl-variant aria-label="Choose an option for ' + esc(p.title) + '">';
      variants.forEach(function (v) {
        selectHtml += '<option value="' + v.id + '"' +
          (chosen && String(v.id) === String(chosen.id) ? ' selected' : '') +
          (v.available ? '' : ' disabled') + '>' +
          esc(v.title) + (v.available ? '' : ' — sold out') + '</option>';
      });
      selectHtml += '</select>';
    }

    var actionsHtml =
      '<div class="oggon-wl-actions">' +
        '<button type="button" class="oggon-wl-buy" data-wl-buy data-variant="' + (chosen ? chosen.id : '') + '"' +
          (available ? '' : ' disabled') + '>' +
          (available ? ICON_BOLT + 'Buy now' : 'Sold out') +
        '</button>' +
        (mode === 'shared'
          ? '<button type="button" class="oggon-wl-save' + (has(p.handle) ? ' is-on' : '') + '" data-wl-saveshared aria-label="Save to my wishlist" title="Save to my wishlist">' + ICON_HEART + '</button>'
          : '') +
      '</div>';

    var removeHtml = mode === 'mine'
      ? '<button type="button" class="oggon-wl-remove" data-wl-remove aria-label="Remove ' + esc(p.title) + ' from wishlist">' + ICON_CLOSE + '</button>'
      : '';

    return '' +
      '<div class="oggon-wl-item" style="--i:' + index + '" data-wl-item data-handle="' + esc(p.handle) + '"' +
        ' data-price="' + (available ? price : 0) + '" data-compare="' + (available && compare > price ? compare : (available ? price : 0)) + '">' +
        '<a class="oggon-wl-item__img" href="' + esc(url) + '" tabindex="-1" aria-hidden="true">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="92" height="92">' : '') +
        '</a>' +
        '<div class="oggon-wl-item__info">' +
          '<a class="oggon-wl-item__title" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
          '<div class="oggon-wl-meta">' + stockHtml + (agoTxt ? '<span class="oggon-wl-ago">' + esc(agoTxt) + '</span>' : '') + '</div>' +
          priceHtml +
          dropHtml +
          selectHtml +
          actionsHtml +
        '</div>' +
        removeHtml +
      '</div>';
  }

  // Cross-fade the row's thumbnail to the newly chosen colour's photo.
  function swapItemImage(row, src) {
    if (!src) return;
    var img = row.querySelector('.oggon-wl-item__img img');
    if (!img) return;
    var next = thumb(src, 280);
    if (img.getAttribute('src') === next) return;
    if (REDUCED) { img.src = next; return; }
    img.classList.add('is-swapping');
    var loader = new Image();
    var settle = function () {
      img.src = next;
      // Removing the class in this later task still triggers the fade-in,
      // and never stalls in a background tab the way animation frames do.
      img.classList.remove('is-swapping');
    };
    loader.onload = settle;
    loader.onerror = function () { img.classList.remove('is-swapping'); };
    loader.src = next;
    // Safety net: never leave the photo hidden if the CDN dawdles.
    setTimeout(function () { img.classList.remove('is-swapping'); }, 1600);
  }

  function recalcTotals() {
    if (!drawer || sharedHandles) return;
    var totalEl = drawer.querySelector('[data-wl-total]');
    var savingsEl = drawer.querySelector('[data-wl-savings]');
    var coBtn = drawer.querySelector('[data-wl-checkoutall]');
    var coLabel = drawer.querySelector('[data-wl-checkoutall-label]');
    if (!totalEl) return;

    var total = 0, compareTotal = 0, buyable = 0;
    qsa('[data-wl-item]', drawer).forEach(function (row) {
      var price = parseInt(row.getAttribute('data-price') || '0', 10);
      var compare = parseInt(row.getAttribute('data-compare') || '0', 10);
      if (price > 0) { total += price; compareTotal += Math.max(compare, price); buyable++; }
    });

    totalEl.textContent = formatMoney(total);
    var savings = compareTotal - total;
    if (savings > 0) {
      savingsEl.hidden = false;
      savingsEl.textContent = 'You save ' + formatMoney(savings);
    } else {
      savingsEl.hidden = true;
    }
    if (coBtn) {
      coBtn.disabled = buyable === 0;
      if (coLabel) coLabel.textContent = buyable > 1 ? 'Checkout all · ' + buyable + ' chairs' : 'Checkout';
    }
  }

  function buyNow(btn) {
    var row = btn.closest('[data-wl-item]');
    if (!row) return;
    var sel = row.querySelector('[data-wl-variant]');
    var id = sel ? sel.value : btn.getAttribute('data-variant');
    if (!id) return;

    btn.classList.add('is-loading');
    btn.disabled = true;
    btn.textContent = 'Just a moment…';

    fetch(rootUrl() + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = rootUrl() + '/checkout'; })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.innerHTML = ICON_BOLT + 'Buy now';
        window.location.href = rootUrl() + '/cart/' + id + ':1';
      });
  }

  function checkoutAll(btn) {
    var items = [];
    qsa('[data-wl-item]', drawer).forEach(function (row) {
      var buy = row.querySelector('[data-wl-buy]');
      if (!buy || buy.disabled) return;
      var sel = row.querySelector('[data-wl-variant]');
      var id = sel ? sel.value : buy.getAttribute('data-variant');
      if (id) items.push({ id: Number(id), quantity: 1 });
    });
    if (!items.length) return;

    var label = btn.querySelector('[data-wl-checkoutall-label]');
    btn.classList.add('is-loading');
    btn.disabled = true;
    if (label) label.textContent = 'Preparing your checkout…';

    fetch(rootUrl() + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = rootUrl() + '/checkout'; })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        if (label) label.textContent = 'Checkout all';
        window.location.href = rootUrl() + '/cart';
      });
  }

  /* ---------------------------------------------------------------- share */

  function shareUrl() {
    var hs = handles();
    if (!hs.length) return window.location.origin + rootUrl() + '/';
    return window.location.origin + rootUrl() + '/?oggon_wl=' + encodeURIComponent(hs.join(','));
  }

  function shareWhatsApp() {
    var n = count();
    var text = 'My OGGON chair wishlist — ' + n + ' chair' + (n === 1 ? '' : 's') + ' I shortlisted. Have a look: ' + shareUrl();
    window.open('https://wa.me/?text=' + encodeURIComponent(text), '_blank', 'noopener');
  }

  function copyShareLink(btn) {
    var url = shareUrl();
    var done = function () {
      if (!btn) return;
      btn.classList.add('is-done');
      var prev = btn.innerHTML;
      btn.innerHTML = ICON_CHECK + 'Copied!';
      setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = prev; }, 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done).catch(function () { fallbackCopy(url); done(); });
    } else {
      fallbackCopy(url);
      done();
    }
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (e) { /* best effort */ }
    document.body.removeChild(ta);
  }

  function parseSharedParam() {
    var m = window.location.search.match(/[?&]oggon_wl=([^&]+)/);
    if (!m) return null;
    try {
      var hs = decodeURIComponent(m[1]).split(',')
        .map(function (h) { return h.trim().toLowerCase(); })
        .filter(function (h) { return /^[a-z0-9-]+$/.test(h); })
        .slice(0, 40);
      return hs.length ? hs : null;
    } catch (e) { return null; }
  }

  /* ----------------------------------------------------------------- toast */

  var toast = null, toastTimer = null;

  function buildToast() {
    toast = document.createElement('div');
    toast.className = 'oggon-wl-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('data-oggon-wl-skip', '');
    toast.innerHTML =
      '<div class="oggon-wl-toast__img" data-t-img></div>' +
      '<div class="oggon-wl-toast__body">' +
        '<div class="oggon-wl-toast__label">' + ICON_HEART + '<span data-t-label>Added to wishlist</span></div>' +
        '<p class="oggon-wl-toast__title" data-t-title></p>' +
        '<div class="oggon-wl-toast__links">' +
          '<button type="button" class="oggon-wl-toast__link" data-t-undo hidden>Undo</button>' +
          '<button type="button" class="oggon-wl-toast__link" data-t-open>View wishlist</button>' +
        '</div>' +
      '</div>' +
      '<button type="button" class="oggon-wl-toast__close" aria-label="Dismiss">' + ICON_CLOSE + '</button>' +
      '<span class="oggon-wl-toast__bar"></span>';

    toast.querySelector('.oggon-wl-toast__close').addEventListener('click', hideToast);
    toast.querySelector('[data-t-open]').addEventListener('click', function () { hideToast(); openDrawer(); });
    toast.querySelector('[data-t-undo]').addEventListener('click', function () { undoRemove(); hideToast(); });
    toast.addEventListener('mouseenter', function () { clearTimeout(toastTimer); });
    toast.addEventListener('mouseleave', function () { toastTimer = setTimeout(hideToast, 1500); });
    document.body.appendChild(toast);
  }

  function showToast(kind, title, imageUrl) {
    if (!toast) buildToast();
    clearTimeout(toastTimer);

    var added = kind === 'add';
    toast.classList.toggle('oggon-wl-toast--removed', !added);
    toast.querySelector('[data-t-label]').textContent = added ? 'Added to wishlist' : 'Removed from wishlist';
    toast.querySelector('[data-t-title]').textContent = title || '';
    toast.querySelector('[data-t-undo]').hidden = added;
    toast.querySelector('[data-t-open]').textContent = added ? 'View wishlist' : 'Open wishlist';

    var imgBox = toast.querySelector('[data-t-img]');
    imgBox.innerHTML = imageUrl ? '<img src="' + esc(thumb(imageUrl, 120)) + '" alt="">' : '';
    imgBox.style.display = imageUrl ? '' : 'none';

    toast.classList.remove('is-open');
    void toast.offsetWidth;
    toast.classList.add('is-open');
    toastTimer = setTimeout(hideToast, TOAST_MS);
  }

  function hideToast() {
    clearTimeout(toastTimer);
    if (toast) toast.classList.remove('is-open');
  }

  /* -------------------------------------------------------------- wiring */

  function onHeartClick(btn, e) {
    e.preventDefault();
    e.stopPropagation();

    var handle = btn.getAttribute('data-oggon-wl-handle');
    if (!handle) return;

    var wasSaved = has(handle);
    var card = btn.closest('[data-oggon-wl-done], .card-wrapper, .card') || btn.parentElement;
    var localImg = card ? card.querySelector('img') : null;

    if (wasSaved) {
      remove(handle);
    } else {
      var variantId = btn.getAttribute('data-oggon-wl-variant') || null;
      if (btn.classList.contains('oggon-wl-heart--pdp')) variantId = currentVariantId() || variantId;
      add(handle, variantId);
      btn.classList.remove('is-pop');
      void btn.offsetWidth;
      btn.classList.add('is-pop');
      burst(btn);
      flyToHeader(localImg);
    }

    var quickTitle = '';
    if (card) {
      var t = card.querySelector('.card__heading a, [class*="title"] a, a[href*="/products/"]');
      if (t) quickTitle = (t.textContent || '').trim();
    }
    if (!quickTitle && CFG.product && CFG.product.handle === handle) quickTitle = CFG.product.title || '';

    showToast(wasSaved ? 'remove' : 'add', quickTitle, localImg ? localImg.currentSrc || localImg.src : null);

    fetchProduct(handle).then(function (p) {
      if (!wasSaved) setPriceAtAdd(handle, p.price);
      if (!toast || !toast.classList.contains('is-open')) return;
      toast.querySelector('[data-t-title]').textContent = p.title;
      var box = toast.querySelector('[data-t-img]');
      if (p.image) { box.style.display = ''; box.innerHTML = '<img src="' + esc(thumb(p.image, 120)) + '" alt="">'; }
    }).catch(function () { /* the card thumbnail is good enough */ });
  }

  document.addEventListener('click', function (e) {
    var closest = function (sel) { return e.target.closest ? e.target.closest(sel) : null; };

    var heart = closest('.oggon-wl-heart');
    if (heart) { onHeartClick(heart, e); return; }

    var buy = closest('[data-wl-buy]');
    if (buy) { e.preventDefault(); buyNow(buy); return; }

    var co = closest('[data-wl-checkoutall]');
    if (co) { e.preventDefault(); checkoutAll(co); return; }

    var rm = closest('[data-wl-remove]');
    if (rm) {
      e.preventDefault();
      var row = rm.closest('[data-wl-item]');
      if (row) {
        var h = row.getAttribute('data-handle');
        var title = row.querySelector('.oggon-wl-item__title');
        var img = row.querySelector('.oggon-wl-item__img img');
        row.classList.add('is-leaving');
        setTimeout(function () { remove(h); }, 240);
        showToast('remove', title ? title.textContent : '', img ? img.src : null);
      }
      return;
    }

    var ss = closest('[data-wl-saveshared]');
    if (ss) {
      e.preventDefault();
      var srow = ss.closest('[data-wl-item]');
      if (srow) {
        var sh = srow.getAttribute('data-handle');
        if (has(sh)) { remove(sh); ss.classList.remove('is-on'); }
        else { add(sh); ss.classList.add('is-on'); bumpHeader(); }
      }
      return;
    }

    var saveAll = closest('[data-wl-saveall]');
    if (saveAll) {
      e.preventDefault();
      (sharedHandles || []).forEach(function (h) { add(h); });
      sharedHandles = null;
      renderDrawer();
      bumpHeader();
      return;
    }

    var exitShared = closest('[data-wl-exitshared]');
    if (exitShared) { e.preventDefault(); sharedHandles = null; renderDrawer(); return; }

    var wa = closest('[data-wl-share-wa]');
    if (wa) { e.preventDefault(); shareWhatsApp(); return; }

    var cp = closest('[data-wl-share-copy]');
    if (cp) { e.preventDefault(); copyShareLink(cp); return; }

    var cont = closest('[data-wl-continue]');
    if (cont) { e.preventDefault(); closeDrawer(); return; }

    var opener = closest('[data-oggon-wishlist-open], a[href$="#wishlist"], a[href$="/pages/wishlist"]');
    if (opener) { e.preventDefault(); openDrawer(); }
  }, true);

  document.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('[data-wl-variant]') : null;
    if (!sel) return;
    var row = sel.closest('[data-wl-item]');
    if (!row) return;
    var handle = row.getAttribute('data-handle');
    if (!sharedHandles) setVariant(handle, sel.value);

    var product = pCache[handle];
    var v = product && (product.variants || []).filter(function (x) { return String(x.id) === String(sel.value); })[0];
    var btn = row.querySelector('[data-wl-buy]');
    if (btn && v) {
      btn.setAttribute('data-variant', v.id);
      btn.disabled = !v.available;
      btn.innerHTML = v.available ? ICON_BOLT + 'Buy now' : 'Sold out';
    }
    if (v) {
      row.setAttribute('data-price', v.available ? v.price : 0);
      row.setAttribute('data-compare', v.available && v.compare_at_price > v.price ? v.compare_at_price : (v.available ? v.price : 0));
      var box = row.querySelector('.oggon-wl-item__price');
      if (box) {
        var pct = v.compare_at_price && v.compare_at_price > v.price
          ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0;
        box.innerHTML =
          '<span class="oggon-wl-now">' + esc(formatMoney(v.price)) + '</span>' +
          (pct ? '<s class="oggon-wl-was">' + esc(formatMoney(v.compare_at_price)) + '</s><span class="oggon-wl-off">' + pct + '% OFF</span>' : '');
      }
      var stock = row.querySelector('.oggon-wl-stock');
      if (stock) {
        stock.className = 'oggon-wl-stock' + (v.available ? '' : ' oggon-wl-stock--out');
        stock.textContent = v.available ? 'In stock' : 'Sold out';
      }
      swapItemImage(row, v.image || (product && product.image));
      recalcTotals();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    memo = null;
    refreshAllHearts();
    refreshHeader();
    if (drawer && drawer.classList.contains('is-open')) renderDrawer();
  });

  /* ------------------------------------------------------------ start-up */

  var rescan = debounce(function () {
    scanCards(document);
    scanProductPage();
    if (!headerBtn || !document.body.contains(headerBtn)) mountHeader();
    refreshAllHearts();
    refreshHeader();
    requestAnimationFrame(verifyClickable);
  }, 160);

  var recheck = debounce(verifyClickable, 220);

  function boot() {
    mergeCustomerList();
    buildDrawer();
    scanCards(document);
    scanProductPage();

    if (!mountHeader()) {
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        if (mountHeader() || tries > 12) {
          clearInterval(iv);
          if (!headerBtn) mountFloating();
        }
      }, 400);
    }

    refreshHeader();

    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes && muts[i].addedNodes.length) { rescan(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }

    window.addEventListener('load', rescan);
    window.addEventListener('scroll', recheck, { passive: true });
    window.addEventListener('resize', recheck, { passive: true });
    document.addEventListener('shopify:section:load', rescan);
    requestAnimationFrame(verifyClickable);

    sharedHandles = parseSharedParam();
    if (sharedHandles || /[?&]wishlist=open/.test(window.location.search) || window.location.hash === '#wishlist') {
      setTimeout(openDrawer, 400);
    }
  }

  /* ---------------------------------------------------------- public API */

  window.OggonWishlist = {
    open: openDrawer,
    close: closeDrawer,
    add: add,
    remove: remove,
    undo: undoRemove,
    toggle: function (handle, variantId) { return has(handle) ? remove(handle) : add(handle, variantId); },
    has: has,
    count: count,
    handles: handles,
    variantFor: savedVariant,
    shareUrl: shareUrl,
    refresh: rescan,
    clear: function () { persist([]); changed({ action: 'clear' }); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
